export const Gallery: React.FC<any> = (_props) => {
    return <article> This is the gallery page.</article>;
  };
  